export const getUrlField = (
  shouldSign: boolean,
  defaultFieldName = 'url',
  signatureFieldName = 'signedUrl'
) => (shouldSign ? signatureFieldName : defaultFieldName);
